"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatType = void 0;
var utils_1 = require("./utils");
var generic_1 = require("../staticAnalyzer/generic");
/**
 * Formats a type or generic reference as a human-readable string.
 */
function formatType(type) {
    if (generic_1.isGeneric(type)) {
        return type.genericIdentifier;
    }
    else if (utils_1.isStringType(type)) {
        return "string";
    }
    else if (utils_1.isNumberType(type)) {
        return "number";
    }
    else if (utils_1.isBooleanType(type)) {
        return "boolean";
    }
    else if (typeof type === "string") {
        return type;
    }
    else if (utils_1.isArrayType(type)) {
        return "[" + formatType(type.elements) + "]";
    }
    else if (utils_1.isUnionType(type)) {
        return type.options.map(formatType).join(" | ");
    }
    throw new Error('unhandled type');
}
exports.formatType = formatType;
//# sourceMappingURL=formatter.js.map